import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { SupportService } from "../services/support-service";
@Component({
  selector: "app-vacation-management",
  templateUrl: "./vacation-management.component.html",
  styleUrls: ["./vacation-management.component.scss"],
})
export class VacationManagementComponent implements OnInit {
  pendingList: any;
  approvedRejectedList: any;
  pendingSelectedList: any = [];
  successMessage = "";
  errorMessage = "";
  approvedListError = false;
  copyapprovedRejectedList: any = [];
  flag = false;
  saveVacation = false;
  showPendingError = false;
  copyPendingList: any = [];
  search = '';
  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private supportService: SupportService
  ) {
    this.pendingList = [];
    this.approvedRejectedList = [];
  }

  ngOnInit() {
    sessionStorage.setItem("type", "vacation-management");
    this.getAllVacationByPendingstatus();
    this.getAllVacationByPendingandApprovedstatus();
    if (localStorage.getItem("testCenterName") != null) {
      this.supportService.testCenterName.next(
        localStorage.getItem("testCenterName")
      );
    }

    if (localStorage.getItem("stateName") != null) {
      this.supportService.stateName.next(localStorage.getItem("stateName"));
    }
  }

  changeStatus(type, index) {
    if (type === "yes") {
      this.pendingList[index].vacationStatus = "approved";
    }

    if (type === "no") {
      this.pendingList[index].vacationStatus = "rejected";
    }
    if (this.pendingSelectedList && this.pendingSelectedList.length > 0) {
      for (let i = 0; i < this.pendingSelectedList.length; i++) {
        if (this.pendingSelectedList[i].id === this.pendingList[index].id) {
          this.pendingSelectedList.splice(i, 1);
          break;
        }
      }
      this.pendingSelectedList.push(this.pendingList[index]);
    } else {
      this.pendingSelectedList.push(this.pendingList[index]);
    }
  }

  getAllVacationByPendingandApprovedstatus() {
    const data = {
      technicianId: "",
      pageNum: 0,
      pageSize: 0,
      statusList: ["approved", "rejected"],
    };
    this.appservice.getAllVacationByPendingandApprovedstatus(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.approvedRejectedList = [];
          this.copyapprovedRejectedList = [];
          for (let index = 0; index < res["entity"].length; index++) {
            res["entity"][index].fullName =
              res["entity"][index].techFirstName +
              " " +
              res["entity"][index].techLastName;
            this.approvedRejectedList.push(res["entity"][index]);
            this.copyapprovedRejectedList.push(res["entity"][index]);
          }
          if (this.approvedRejectedList.length === 0) {
            this.approvedListError = true;
            this.approvedRejectedList = [];
            this.copyapprovedRejectedList = [];
          } else {
            this.approvedListError = false;
          }
        } else {
          this.approvedRejectedList = [];
          this.copyapprovedRejectedList = [];
          this.approvedListError = true;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getFullTimeOffBlock(timeOffBlock) {
    if (timeOffBlock === "full" || timeOffBlock === "full_day") {
      timeOffBlock = "full day";
    }
    return timeOffBlock;
  }

  getAprrovedStatus(status): string {
    if (status === "approved") {
      return "Approved";
    }
    if (status === "rejected") {
      return "Rejected";
    }
  }

  saveVacationManagement() {
    if (this.pendingList && this.pendingList.length > 0) {
      this.saveVacation = true;
      this.flag = false;
      for (let index = 0; index < this.pendingSelectedList.length; index++) {
        if (
          this.pendingSelectedList[index].vacationStatus === "approved" ||
          this.pendingSelectedList[index].vacationStatus === "rejected"
        ) {
          const data = {
            id: this.pendingSelectedList[index].id,
            reason: this.pendingSelectedList[index].reason,
            fromDate: this.pendingSelectedList[index].fromDate,
            toDate: this.pendingSelectedList[index].toDate,
            vacationType: {
              id: this.pendingSelectedList[index].vacationType,
            },
            vacationStatus: this.pendingSelectedList[index].vacationStatus,
            replyComment: this.pendingSelectedList[index].replyComment,
            timeOffBlock: this.pendingSelectedList[index].timeOffBlock,
            fromTime: this.pendingSelectedList[index].fromTime,
            toTime: this.pendingSelectedList[index].toTime,
            technicianId: this.pendingSelectedList[index].technicianId,
          };
          this.appservice.addorupdatevacationrequest(data).subscribe(
            (res) => {
              if (res && res["status"] && res["status"]["status"] === 241) {
                this.getAllVacationByPendingstatus();
                this.getAllVacationByPendingandApprovedstatus();
                this.flag = true;
                this.successMessage = "";
                this.errorMessage = "Hours exceed";
              }
              if (res && res["status"] && res["status"]["status"] === 229) {
                this.successMessage = "";
                this.errorMessage = "Technologist not found";
              }

              if (index === this.pendingSelectedList.length - 1) {
                if (!this.flag) {
                  this.getAllVacationByPendingstatus();
                  this.getAllVacationByPendingandApprovedstatus();
                  this.successMessage = "Success";
                  this.saveVacation = false;
                  setTimeout(() => {
                    this.successMessage = "";
                    this.errorMessage = "";
                  }, 5000);
                } else if (this.flag) {
                  this.errorMessage = "Hours exceed";
                  this.saveVacation = false;
                  setTimeout(() => {
                    this.errorMessage = "";
                  }, 5000);
                }
              }
            },
            (err) => {
              this.appservice.sessionOut(err);
            }
          );
        }
      }
    }
  }

  transformDate(date): string {
    if (date) {
      return this.datepipe.transform(date, "MMM d, y"); // 2018-11-23
    }
  }

  getAllVacationByPendingstatus() {
    const data = {
      technicianId: "",
      pageNum: 0,
      pageSize: 0,
      statusList: "pending",
    };
    this.appservice.getAllVacationByPendingandApprovedstatus(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.pendingList = [];
          this.pendingSelectedList = [];
          this.copyPendingList = [];
          for (let index = 0; index < res["entity"].length; index++) {
            res["entity"][index].exceed = false;
            if (!res["entity"][index].replyComment) {
              res["entity"][index].fullName =
                res["entity"][index].techFirstName +
                " " +
                res["entity"][index].techLastName;
              this.pendingList.push(res["entity"][index]);
              this.copyPendingList.push(res["entity"][index]);
            }
          }
          if (this.pendingList.length === 0) {
            this.showPendingError = true;
            this.pendingList = [];
            this.copyPendingList = [];
            this.pendingSelectedList = [];
          } else {
            this.showPendingError = false;
          }
        } else {
          this.pendingList = [];
          this.copyPendingList = [];
          this.showPendingError = true;
          this.pendingSelectedList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  filterItem(value) {
    if (!value) {
      this.getAllVacationByPendingstatus();
      this.getAllVacationByPendingandApprovedstatus();
    } else {
      this.pendingList = Object.assign([], this.copyPendingList).filter(
        (item) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      this.approvedRejectedList = Object.assign(
        [],
        this.copyapprovedRejectedList
      ).filter(
        (item) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );

      if (
        this.pendingList.length === 0 ||
        this.approvedRejectedList.length === 0
      ) {
        this.clearFilter();
      }
    }
  }

  clearFilter() {
    if (this.pendingList.length === 0) {
      this.pendingList = [];
      this.showPendingError = true;
    }
    if (this.approvedRejectedList.length === 0) {
      this.approvedRejectedList = [];
      this.approvedListError = true;
    }
  }
}
